export function getRelatedExpressions(itemExpressionUri: string, offset: any, pagesize: any, rangeStart: any, rangeEnd: any){
  let rangeFilter;
  if (rangeStart && rangeEnd){
   rangeFilter = ["FILTER (?isRelatedToRangeEnd <=" + rangeEnd + ")",
                 "FILTER (?isRelatedToRangeStart >=" + rangeStart + ")"].join(" ")
  }
  let activeSource; 
  if (!rangeStart && !rangeEnd){
   activeSource = [ 
     "{",
       "?element <http://scta.info/property/source> ?isRelatedTo .",
       "FILTER (!isBlank(?isRelatedTo)) .",
     "}",
     "UNION",
     "{",
     "?element <http://scta.info/property/source> ?bn .",
     "?bn <http://scta.info/property/source> ?isRelatedTo .",
     "?bn <http://scta.info/property/canonicalRangeStart> ?isRelatedToRangeStart .",
     "?bn <http://scta.info/property/canonicalRangeEnd> ?isRelatedToRangeEnd .",
     "}"].join(" ")
   }
   else{
     activeSource = ["?element <http://scta.info/property/source> ?bn .",
     "?bn <http://scta.info/property/source> ?isRelatedTo .",
     "?bn <http://scta.info/property/canonicalRangeStart> ?isRelatedToRangeStart .",
     "?bn <http://scta.info/property/canonicalRangeEnd> ?isRelatedToRangeEnd .",
     rangeFilter].join(" ")
   }
  
   let inverseSource;
  if (!rangeStart && !rangeEnd){
   inverseSource = ["{",
           "?isRelatedTo <http://scta.info/property/source> ?element .",
         "}",
           "UNION",
         "{",
           "?isRelatedTo <http://scta.info/property/source> ?bn .",
           "?bn <http://scta.info/property/source> ?element .",
           "?bn <http://scta.info/property/canonicalRangeStart> ?isRelatedToRangeStart .",
           "?bn <http://scta.info/property/canonicalRangeEnd> ?isRelatedToRangeEnd .",
         "}"].join(" ")
  }
  else{
   inverseSource = ["?isRelatedTo <http://scta.info/property/source> ?bn .",
   "?bn <http://scta.info/property/source> ?element .",
   "?bn <http://scta.info/property/canonicalRangeStart> ?isRelatedToRangeStart .",
   "?bn <http://scta.info/property/canonicalRangeEnd> ?isRelatedToRangeEnd .",
   rangeFilter].join(" ")
  }
 //OLD QUERY THAT STOPPED WORKING As part of update to fuseki 4.3
 //  const query = [
 //   "SELECT DISTINCT ?isRelatedTo ?label ?element ?longTitle ?author ?authorTitle ?isRelatedToRangeStart ?isRelatedToRangeEnd ",
 //   "WHERE",
 //   "{ ",
 //   "BIND (<" + itemExpressionUri + "> as ?resource)",
 //     "{",
 //       "?resource ?o ?isRelatedTo .",
 //       "?o a <http://scta.info/resource/textRelation> .",
 //       "FILTER (?o != <http://scta.info/property/quotes>)",
 //       "FILTER (?o != <http://scta.info/property/quotedBy>)", 
 //       "FILTER (?o != <http://scta.info/property/references>)", 
 //       "FILTER (?o != <http://scta.info/property/referencedBy>)", 
 //       "?o <http://www.w3.org/1999/02/22-rdf-syntax-ns#label> ?label . ",
 //       "?isRelatedTo a <http://scta.info/resource/expression> .",
 //     "}",
 //     "UNION",
 //     "{",
 //       "{",
 //         "?resource <http://scta.info/property/structureType> <http://scta.info/resource/structureElement> .",
 //         "BIND (?resource as ?element)",
 //       "}",
 //       "UNION",
 //       "{",
 //         "?element <http://scta.info/property/isMemberOf> ?resource .",
 //       "}",
 //       "{",
 //           activeSource,
 //           "?element <http://scta.info/property/structureElementType> <http://scta.info/resource/structureElementQuote> .",
 //           "BIND ('quotes' as ?label) .",
 //         "}",
 //       "UNION",
 //       "{",
 //         activeSource,
 //         "?element <http://scta.info/property/structureElementType> <http://scta.info/resource/structureElementRef> .",
 //         "BIND ('refs' as ?label) .",
 //       "}",
 //     "}",
 //     "UNION", 
 //     "{",
 //       "{",
 //         "BIND (?resource as ?element)",
 //       "}",
 //       "UNION",
 //       "{",
 //         "?element <http://scta.info/property/isMemberOf> ?resource .",
 //       "}",
 //       "{",
 //         inverseSource,
 //         "?isRelatedTo <http://scta.info/property/structureElementType> <http://scta.info/resource/structureElementQuote> .",
 //         "BIND ('isQuotedBy' as ?label) .",
 //       "}",
 //       "UNION",
 //       "{",
 //         inverseSource,
 //         //"?isRelatedTo <http://scta.info/property/source> ?element.",
 //         "?isRelatedTo <http://scta.info/property/structureElementType> <http://scta.info/resource/structureElementRef> .",
 //         "BIND ('isReferencedBy' as ?label) .",
 //       "}",
 //     "}",
 //     "?isRelatedTo <http://scta.info/property/longTitle> ?longTitle .",
 //     "?isRelatedTo <http://scta.info/property/isMemberOf> ?mem .",
 //     "?mem <http://scta.info/property/level> '1' .",
 //     "OPTIONAL",
 //     "{",
 //       "?mem <http://www.loc.gov/loc.terms/relators/AUT> ?author .",
 //       "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle",
 //     "}",
 //   "}",
 //   "ORDER BY ?authorTitle",
 //   "LIMIT " + pagesize,
 //   "OFFSET " + offset
 //  ].join(' ');

 const query = [
 "SELECT DISTINCT ?isRelatedTo ?label ?element ?longTitle ?author ?authorTitle ?isRelatedToRangeStart ?isRelatedToRangeEnd ?parentBlock ?parentBlockTranscription ?isRelatedToTranscription ",
 "WHERE",
 "{ ",
   "BIND (<" + itemExpressionUri  + "> AS ?resource) .",
   "{",
     "<" + itemExpressionUri  + "> ?o ?isRelatedTo . ",
     "?o a <http://scta.info/resource/textRelation> . ", 
     "FILTER (?o != <http://scta.info/property/quotes>) . ",
     "FILTER (?o != <http://scta.info/property/quotedBy>) . ",
     "FILTER (?o != <http://scta.info/property/references>).",
     "FILTER (?o != <http://scta.info/property/referencedBy>).", 
     "?o <http://www.w3.org/1999/02/22-rdf-syntax-ns#label> ?label . ",
     "?isRelatedTo a <http://scta.info/resource/expression> . ",
     "}", 
     "UNION", 
   "{",
     "{",
     "<" + itemExpressionUri  + "> <http://scta.info/property/structureType> <http://scta.info/resource/structureElement> . ",
       "BIND (<" + itemExpressionUri  + "> as ?element) .",
     "} ",
     "UNION", 
     "{",
       "?element <http://scta.info/property/isMemberOf> <" + itemExpressionUri  + ">  . ",
     "}",
     "{ ",
         activeSource,
         "{",
           "?element <http://scta.info/property/structureElementType> <http://scta.info/resource/structureElementQuote> . ",
           "BIND ('quotes' as ?label) . ",
         "}",
         "UNION",
         "{",
           "?element <http://scta.info/property/structureElementType> <http://scta.info/resource/structureElementRef> . ",
           "BIND ('refs' as ?label) . ",
         "}",
       "} ",
   "} ",
   "UNION",
   "{ ",
   "{ ",
     "BIND (<" + itemExpressionUri  + ">  as ?element) .",
     "} ",
     "UNION ",
     "{ ",
     "?element <http://scta.info/property/isMemberOf> <" + itemExpressionUri  + ">  . ",
     "}",
     inverseSource,
     "{",
     " ?isRelatedTo <http://scta.info/property/structureElementType> <http://scta.info/resource/structureElementQuote> . ",
     " BIND ('isQuotedBy' as ?label) . ",
     "} ",
     "UNION", 
     "{ ",
       "?isRelatedTo <http://scta.info/property/structureElementType> <http://scta.info/resource/structureElementRef> . ",
       "BIND ('isReferencedBy' as ?label) . ",
     "}",
     "OPTIONAL",
     "{",
       "?isRelatedTo <http://scta.info/property/isPartOfStructureBlock> ?parentBlock .",
       "?parentBlock <http://scta.info/property/hasCanonicalManifestation> ?parentBlockManifestation .",
       "?parentBlockManifestation <http://scta.info/property/hasCanonicalTranscription> ?parentBlockTranscription .",
       //"?isRelatedTo <http://scta.info/property/isMemberOf> ?parentBlock .",
       //"?parentBlock <http://scta.info/property/structureType> <http://scta.info/resource/stuctureBlock> .",
     "}",
   "}",
   "?isRelatedTo <http://scta.info/property/longTitle> ?longTitle . ",
   "?isRelatedTo <http://scta.info/property/isMemberOf> ?mem . ",
   "?mem <http://scta.info/property/level> '1' . ",
   "?isRelatedTo <http://scta.info/property/hasCanonicalManifestation> ?isRelatedToManifestation .",
   "?isRelatedToManifestation <http://scta.info/property/hasCanonicalTranscription> ?isRelatedToTranscription .",
   "OPTIONAL ",
   "{ ",
     "?mem <http://www.loc.gov/loc.terms/relators/AUT> ?author . ",
     "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .",
   "} ",
 "} ",
 "ORDER BY ?authorTitle",
 "LIMIT " + pagesize,
 "OFFSET " + offset
].join(' ');
    return query
}